import { Component } from '@angular/core';
import { Error } from 'src/app/components/error/error';

@Component({
  selector: 'app-error-page',
  imports: [Error],
  templateUrl: './error-page.html',
  styleUrl: './error-page.scss',
})
export class ErrorPage {}
